
let intervalId;

function closeActiveMenu() {
  $('.parent-link > a.active').each((_, el) => {
    $(el).removeClass('active');
    $(el).closest('.parent-link').find('.child-menu').fadeOut(500);
    $(el).closest('.parent-link').find('.menu-toggle').removeClass('active');
  });
}

$(document).ready(() => {

  $('#mobileMenuContainer .menu-toggle').click(function() {
    window.scrollTo(0, 0);
    $(this).next().slideToggle(500);
    $(this).toggleClass('active');
    $(this).closest('.parent-link').find('.menu-link').toggleClass('active');
  });

  $('#mobileMenuContainer a:not([href="#"])').click(function() {
    $('#mobileMenuToggle').click()
  });

  $('body').click(function (e) {
    if ($(e.target).closest('.parent-link').length === 0) {
      closeActiveMenu();
    }
  })

  $('.parent-link > a').click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    const isActive = $(this).hasClass('active');
    closeActiveMenu();

    if (!isActive) {
      $(this).addClass('active');
      $(this).closest('.parent-link').find('.child-menu').fadeIn(500);
      $(this).closest('.parent-link').find('.menu-toggle').addClass('active');
    }
  });

  $('.announcement__close').click(function (e) {
    $('.announcement').hide();
    localStorage.setItem('hide_announcement', '1');
  })

  const hideAnnouncement = localStorage.getItem('hide_announcement');
  if (hideAnnouncement !== '1') {
    $('.announcement').show();
  }

  let lastScrollTop = 0;
  $(window).on('scroll', function () {
    const st = $(this).scrollTop();
    const header = $('#shopify-section-cad-header');
    const page_container = $('body');

    const BaSNewDiscountProgress = $('.page-build_a_system_new .discount-progress-wrapper')?.parent()
    const BaSNewPreviewContainer = $('.stickyContainer', '.page-build_a_system_new ')
    const headerHeight = header.height();
    header.css('top', -headerHeight);

    if (st > lastScrollTop){
      header.removeClass('fixed');
      page_container.removeClass('navigation-shown');
      if (isDesktop()) {
        BaSNewDiscountProgress?.css('top', 0);
        BaSNewPreviewContainer?.css('top', BaSNewDiscountProgress.height());
      }

    } else {
      header.addClass('fixed');
      page_container.addClass('navigation-shown');
      if (isDesktop()) {
        BaSNewDiscountProgress?.css('top', headerHeight);
        BaSNewPreviewContainer?.css('top', BaSNewDiscountProgress.height() + headerHeight);
      }

    }

    lastScrollTop = st;
  })

  function animateAnnouncement() {
    const currentActiveItem = $('.announcement__wrapper.active')
    currentActiveItem.removeClass('active');
    const nextSibling = currentActiveItem.next();
    const nextActiveItem = nextSibling.length > 0 ? nextSibling : initialAnnouncement;
    nextActiveItem.addClass('active');
  }


  function showNextAnnouncement() {
    clearInterval(intervalId);
    const animationTimeout = 30000; 
    intervalId = setInterval(animateAnnouncement, animationTimeout);
    const currentActiveItem = $('.announcement__wrapper.active');
    const announcements = $('.announcement__wrapper');
    const initialAnnouncement = $(announcements[0]);
    currentActiveItem.removeClass('active');
    const nextSibling = currentActiveItem.next();
    
    const nextActiveItem = nextSibling.length > 0 ? nextSibling : initialAnnouncement;

    nextActiveItem.addClass('active');
  }
  
  function showPreviousAnnouncement() {
    clearInterval(intervalId);
    const animationTimeout = 30000; 
    intervalId = setInterval(animateAnnouncement, animationTimeout);

    const currentActiveItem = $('.announcement__wrapper.active')
    currentActiveItem.removeClass('active');
    const announcements = $('.announcement__wrapper');
    const lastAnnouncement = $(announcements[announcements.length - 1]);
    const nextSibling = currentActiveItem.prev();
    
    const nextActiveItem = nextSibling.length > 0 ? nextSibling : lastAnnouncement;

    nextActiveItem.addClass('active');
  }


  const announcements = $('.announcement__wrapper');
  const animationTimeout = parseFloat($('.announcement').data('animation-timeout'));
  if (!announcements.length) return;

  const initialAnnouncement = $(announcements[0])
  initialAnnouncement.addClass('active');
  if (announcements.length < 2) return;

  intervalId = setInterval(animateAnnouncement, animationTimeout);

    $('.new_announcement__arrow-left').click(showPreviousAnnouncement);
    $('.new_announcement__arrow-right').click(showNextAnnouncement);
});
